import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = { "clip-path": "url(#clip0_2895_902)" }
const _hoisted_3 = ["stroke"]
const _hoisted_4 = ["stroke"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_2895_902" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "9.5",
      height: "9.5",
      fill: "white",
      transform: "translate(0.75 0.5)"
    })
  ])
], -1)

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'chevrons',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#211F58",
  },
  width: {
    type: Number as PropType<number>,
    default: 11,
  },
  height: {
    type: Number as PropType<number>,
    default: 10,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: __props.width ?? '11',
    height: __props.height ?? '10',
    viewBox: `0 0 ${__props.width ?? '11'} ${__props.height ?? '10'}`,
    fill: "none"
  }, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("path", {
        d: "M9.71911 8.94377L6.28547 5.34438C6.22587 5.28184 6.19238 5.19703 6.19238 5.1086C6.19238 5.02017 6.22587 4.93536 6.28547 4.87283L9.71911 1.27344",
        stroke: __props.color,
        "stroke-width": "1.05556",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, _hoisted_3),
      _createElementVNode("path", {
        d: "M5.23571 8.94377L1.80207 5.34438C1.74247 5.28184 1.70898 5.19703 1.70898 5.1086C1.70898 5.02017 1.74247 4.93536 1.80207 4.87283L5.23571 1.27344",
        stroke: __props.color,
        "stroke-width": "1.05556",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, _hoisted_4)
    ]),
    _hoisted_5
  ], 8, _hoisted_1))
}
}

})